import {Type} from 'class-transformer';
import {Movie} from '../movie';

export class MovieImportUploadResponse {
  migrationId: string = '';
  totalRows: number = 0;
  sourceFilePath: string = '';
  @Type(() => MovieImportMissingTaxonomies)
  missingTaxonomies: MovieImportMissingTaxonomies = new MovieImportMissingTaxonomies();
}

export class MovieImportMigrationResponse {
  migrationId: string = '';
  totalRows: number = 0;
  @Type(() => MovieImportRow)
  entries: MovieImportRow[] = [];
  @Type(() => MovieImportMissingTaxonomies)
  missingTaxonomies: MovieImportMissingTaxonomies = new MovieImportMissingTaxonomies();
}

 export enum MovieImportMode {
  Upsert = 1
}

export class MovieImportCommitRequest {
  importMode: MovieImportMode = MovieImportMode.Upsert;
  entries: MovieImportCommitEntryRequest[] = [];
}

export class MovieImportCommitEntryRequest {
  key: string | null = null;
  rowNumber: number | null = null;
}

export class MovieImportCommitResponse {
  migrationId: string = '';
  imported: number = 0;
  updated: number = 0;
}

export class MovieImportMissingTaxonomies {
  genres: string[] = [];
  subGenres: string[] = [];
}

export class MovieImportRow {
  rowNumber: number = 0;
  @Type(() => Movie)
  movie: Movie = new Movie();
  genreName?: string;
  subGenreName?: string;
  genreId?: number;
  subGenreId?: number;
  @Type(() => MovieImportImageReferences)
  images: MovieImportImageReferences = new MovieImportImageReferences();
}

export class MovieImportImageReferences {
  coverImageIt: string = '';
  coverImageEn: string = '';
  sliderImageIt: string = '';
  sliderImageEn: string = '';
}
